import React from 'react'

const ChipRating = ({ name, scaleAE, primaryColor, secondaryColor, size = 'medium' }) => {
  return (
    <div
      className='flex items-center justify-start  gap-2 py-1 px-2 min-w-150px'
      style={{ borderRadius: 50, backgroundColor: 'rgba(0, 0, 0, 0.08)' }}
    >
      <div
        className='flex items-center justify-center rounded-full text-lg bg-loading '
        style={{
          width: scaleAE ? 22 : 12,
          height: scaleAE ? 22 : 12,
          backgroundColor: secondaryColor || 'rgba(0, 0, 0, 0.2) ',
          color: primaryColor || 'currentColor'
        }}
      >
        {scaleAE}
      </div>

      <p className={['text-nowrap pr-2', size === 'medium' ? 'text-sm' : 'text-xs'].join(' ')}>{name}</p>
    </div>
  )
}

export default ChipRating
